import { Text, View, StyleSheet } from "@react-pdf/renderer";
import { formatFechaISOLocal } from "../../../services/fechas";
const styles = StyleSheet.create({
  topBox: {
    border: "1pt solid #000",
    padding: 10,
  },
  topRow: {
    flexDirection: "row",
    alignItems: "center",
  },
  topCol: {
    paddingVertical: 4,
    paddingHorizontal: 6,
  },
  topColLeft: {
    flex: 2,
  },
  topColCenter: {
    flex: 8,
    textAlign: "center",
  },
  topColRight: {
    flex: 2,
    textAlign: "right",
  },
  midBox: {
    border: "1pt solid #000",
    marginTop: 3,
  },
  midRow: {
    flexDirection: "row",
  },
  midCol: {
    paddingVertical: 0,
    paddingHorizontal: 0,
  },
  midLeft: {
    flex: 3,
    borderRight: "1pt solid #000",
  },
  midCenter: {
    flex: 6,
    borderRight: "1pt solid #000",
    justifyContent: "center",
    alignItems: "center",
  },
  midRight: {
    flex: 3,
  },
  midLine: {
    flexDirection: "row",
    borderBottom: "1pt solid #000",
    paddingVertical: 2,
  },
  midLineLast: {
    flexDirection: "row",
    paddingVertical: 3,
  },
  midLabel: {
    fontSize: 9,
    fontWeight: "bold",
    marginRight: 6,
    marginLeft: 3,
  },
  midValue: {
    fontSize: 9,
  },
  midCenterText: {
    fontSize: 12,
    fontWeight: "bold",
  },
});

function DocumentHeader({ headers, contract }) {
  const data = headers?.data ?? headers ?? {};

  return (
    <>
      <View style={styles.topBox}>
        <View style={styles.topRow}>
          <View style={[styles.topCol, styles.topColLeft]}>
            <Text>{headers?.contracT_CODE ?? "SG3Plus"}</Text>
          </View>

          <View style={[styles.topCol, styles.topColCenter]}>
            <Text>ESTADO DE PAGO N° {data?.nrO_EP}</Text>
          </View>

          <View style={[styles.topCol, styles.topColRight]}>
            <Text>{headers?.meS_EP ?? ""}</Text>
          </View>
        </View>
      </View>

      <View style={styles.midBox}>
        <View style={[styles.midRow]}>
          {/* Columna izquierda */}
          <View style={[styles.midCol, styles.midLeft, { width: "25%" }]}>
            <View style={styles.midLine}>
              <Text style={styles.midLabel}>Contrato N° :</Text>
              <Text style={styles.midValue}>{data?.contracT_CODE ?? ""}</Text>
            </View>
            <View style={[styles.midLine]}>
              <Text style={styles.midLabel}>Contratista :</Text>
              <Text
                hyphenationCallback={(word) => [word]}
                style={[styles.midValue, { fontSize: 8, maxWidth: "70%" }]}
              >
                {data?.contracT_EECC ?? ""}
              </Text>
            </View>
            <View style={styles.midLineLast}>
              <Text style={styles.midLabel}>Título :</Text>
              <Text
                hyphenationCallback={(word) => [word]}
                style={[styles.midValue, { fontSize: 8, maxWidth: "77%" }]}
              >
                {data?.contracT_NAME ?? ""}
              </Text>
            </View>
          </View>

          {/* Columna centro */}
          <View style={[styles.midCol, styles.midCenter, { width: "50%" }]}>
            <Text style={styles.midCenterText}>
              {contract.data.legalEntityBuyerName ?? "Entidad Compradora"}
            </Text>
          </View>

          {/* Columna derecha */}
          <View style={[styles.midCol, styles.midRight, { width: "25%" }]}>
            <View style={styles.midLine}>
              <Text style={styles.midLabel}>Fecha de presentacion :</Text>
              <Text style={styles.midValue}>
                {formatFechaISOLocal(data?.fecha_preparacion)}
              </Text>
            </View>
            <View style={styles.midLine}>
              <Text style={styles.midLabel}>Periodo de pago :</Text>
              <Text style={styles.midValue}>{data?.meS_EP ?? ""}</Text>
            </View>
            <View style={styles.midLineLast}>
              <Text style={styles.midLabel}>Moneda :</Text>
              <Text style={styles.midValue}>{data?.moneda ?? ""}</Text>
            </View>
          </View>
        </View>
      </View>
    </>
  );
}

export default DocumentHeader;
